import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  name: 'HomeStatistics',
  data: function data() {
    return {
      memberStsData: null,
      memberStsTodayData: null,
      selectIndexActivityData: null,
      newDatas: null,
      methNewDatas: null
    };
  },
  methods: {
    exportExcel: function exportExcel() {
      var apiUrl = 'admin/home/exportGetMetCount';
      this.downloadUtil.excelExport(apiUrl, {}, '平台月度数据统计表.xls');
    },
    initData: function initData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_INDEX_TOTAL_STATISTICS();
            case 1:
              res = _context.v;
              _this.memberStsData = res.body;
              _context.n = 2;
              return api.GET_INDEX_TODAY_TOTAL_STATISTICS();
            case 2:
              res = _context.v;
              _this.memberStsTodayData = res.body;
              _context.n = 3;
              return api.SELECT_INDEX_ACTIVITY_DATA();
            case 3:
              res = _context.v;
              _this.selectIndexActivityData = res.body;
              _context.n = 4;
              return api.GET_HOME_COUNT();
            case 4:
              res = _context.v;
              _this.newDatas = res.body;
              _context.n = 5;
              return api.GET_HOME_getMetCount();
            case 5:
              res = _context.v;
              _this.methNewDatas = res.body;
            case 6:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.initData();
  }
};